import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout';
import { useTheme } from './hooks';

// 路由懒加载
const DashboardPage = lazy(() => import('./pages/DashboardPage').then(m => ({ default: m.DashboardPage })));
const TrendPage = lazy(() => import('./pages/TrendPage').then(m => ({ default: m.TrendPage })));
const ComparePage = lazy(() => import('./pages/ComparePage').then(m => ({ default: m.ComparePage })));
const NewsPage = lazy(() => import('./pages/NewsPage').then(m => ({ default: m.NewsPage })));
const NewsDetailPage = lazy(() => import('./pages/NewsDetailPage').then(m => ({ default: m.NewsDetailPage })));
const AdvicePage = lazy(() => import('./pages/AdvicePage').then(m => ({ default: m.AdvicePage })));
const KnowledgePage = lazy(() => import('./pages/KnowledgePage').then(m => ({ default: m.KnowledgePage })));
const SettingsPage = lazy(() => import('./pages/SettingsPage').then(m => ({ default: m.SettingsPage })));

// 管理后台懒加载
const AdminGuard = lazy(() => import('./pages/admin/AdminGuard').then(m => ({ default: m.AdminGuard })));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout').then(m => ({ default: m.AdminLayout })));
const AdminDashboardPage = lazy(() => import('./pages/admin/AdminDashboardPage').then(m => ({ default: m.AdminDashboardPage })));
const DataCollectPage = lazy(() => import('./pages/admin/DataCollectPage').then(m => ({ default: m.DataCollectPage })));
const SystemSettingsPage = lazy(() => import('./pages/admin/SystemSettingsPage').then(m => ({ default: m.SystemSettingsPage })));

// 加载骨架屏
function PageSkeleton() {
  return (
    <div className="space-y-6 p-6">
      <div className="h-8 w-48 bg-border rounded animate-pulse" />
      <div className="h-64 bg-border rounded animate-pulse" />
      <div className="h-32 bg-border rounded animate-pulse" />
    </div>
  );
}

function App() {
  // 初始化主题
  useTheme();

  return (
    <BrowserRouter>
      <Routes>
        {/* 公开前台 */}
        <Route element={<Layout />}>
          <Route path="/" element={<Suspense fallback={<PageSkeleton />}><DashboardPage /></Suspense>} />
          <Route path="/trend" element={<Suspense fallback={<PageSkeleton />}><TrendPage /></Suspense>} />
          <Route path="/compare" element={<Suspense fallback={<PageSkeleton />}><ComparePage /></Suspense>} />
          <Route path="/news" element={<Suspense fallback={<PageSkeleton />}><NewsPage /></Suspense>} />
          <Route path="/news/:id" element={<Suspense fallback={<PageSkeleton />}><NewsDetailPage /></Suspense>} />
          <Route path="/advice" element={<Suspense fallback={<PageSkeleton />}><AdvicePage /></Suspense>} />
          <Route path="/knowledge" element={<Suspense fallback={<PageSkeleton />}><KnowledgePage /></Suspense>} />
          <Route path="/settings" element={<Suspense fallback={<PageSkeleton />}><SettingsPage /></Suspense>} />
        </Route>

        {/* 管理后台 */}
        <Route
          path="/admin"
          element={
            <Suspense fallback={<PageSkeleton />}>
              <AdminGuard>
                <AdminLayout />
              </AdminGuard>
            </Suspense>
          }
        >
          <Route index element={<Suspense fallback={<PageSkeleton />}><AdminDashboardPage /></Suspense>} />
          <Route path="collect" element={<Suspense fallback={<PageSkeleton />}><DataCollectPage /></Suspense>} />
          <Route path="settings" element={<Suspense fallback={<PageSkeleton />}><SystemSettingsPage /></Suspense>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;